import { Component, OnInit } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-automotive-solution',
  templateUrl: './automotive-solution.component.html',
  styleUrls: ['./automotive-solution.component.scss'],
  standalone: false
})
export class AutomotiveSolutionComponent implements OnInit {
  sholutionToShow = 0;
  constructor() { }
  Images = IMAGES;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

  showCarIQAutomotiveSolution(solution) {
    this.sholutionToShow = solution;
  }

}
